import { IconProps } from '.';

const InfoIcon = ({ color, customClasses }: IconProps) => {
  return (
    <svg
      className={customClasses}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM9.25 15V9H10.75V15H9.25ZM9.25 5.5V7H10.75V5.5H9.25Z"
        fill={color || 'var(--color-ui-icon-primary)'}
      />
    </svg>
  );
};

export default InfoIcon;
